<forge-menu [options]="menuOptions" (forge-menu-select)="onForgeMenuItemSelect($event)" (forge-menu-open)="menuOpened($event)">
    <forge-icon-button [disabled]="disabled" [dense]="dense">
        <forge-icon [name]="icon"></forge-icon>
    </forge-icon-button>
</forge-menu>